import React from 'react';
import { Delete, Shuffle, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface StickyActionBarProps {
  onQuickPick: () => void;
  onFavouritePick: () => void;
  onClear: () => void;
  hasAnyPicks?: boolean;
  className?: string;
  showFavouritePick?: boolean;
}

const StickyActionBar: React.FC<StickyActionBarProps> = ({
  onQuickPick,
  onFavouritePick,
  onClear,
  hasAnyPicks = false,
  className = '',
  showFavouritePick = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`z-30 w-full overflow-hidden bg-background px-6 pt-4 ${className}`}
      data-test-id="sticky-action-bar"
    >
      <div className="flex w-full min-w-0 items-center justify-between gap-3">
        <div className="flex min-w-0 flex-1 gap-3">
          <Button
            variant="muted"
            size="micro"
            shape="rounded"
            onClick={onQuickPick}
            className="min-w-0 flex-1"
            data-test-id="quick-pick-button"
            showTrailingIcon={false}
          >
            <span className="truncate">{t('actions.quickPick')}</span>
            <Shuffle className="size-4 shrink-0" />
          </Button>

          {showFavouritePick && (
            <Button
              variant="muted"
              size="micro"
              onClick={onFavouritePick}
              className="min-w-0 flex-1"
              data-test-id="favourite-pick-button"
              showTrailingIcon={false}
            >
              <span className="truncate">{t('actions.favouritePick')}</span>
              <Star className="size-4 shrink-0" />
            </Button>
          )}
        </div>

        {hasAnyPicks && (
          <Button
            variant="muted"
            size="icon"
            onClick={onClear}
            className="h-auto shrink-0 p-2"
            data-test-id="clear-picks-button"
            aria-label={t('actions.clear')}
            showTrailingIcon={false}
          >
            <Delete className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default StickyActionBar;
